import { Container, Title, Text, Card, Anchor, Badge, Stack, Box, Divider } from '@mantine/core';
import { sourcesData } from '../data/symtomsData';

const sourceDetails: { type: string; color: string }[] = [
  { type: "Medical Textbook", color: "blue" },
  { type: "Clinical Foundation", color: "teal" },
  { type: "NIH Database", color: "violet" },
  { type: "Rare Disease Org", color: "orange" },
  { type: "Peer-Reviewed Study", color: "pink" },
];

const SourcesPage = () => {
  return (
    <Container size="lg" py="xl">
      <Title order={1} mb="md" c="gray.1">Medical Sources & References</Title>
      <Text size="lg" mb="xs" c="gray.3">
        All statistics, symptom data, and clinical information on this site are drawn from
        peer-reviewed medical literature and authoritative healthcare organisations.
      </Text>
      <Text size="sm" mb="xl" c="gray.4" style={{ fontStyle: 'italic' }}>
        This site is for educational purposes only and does not constitute medical advice.
        Always consult a qualified healthcare professional for diagnosis and treatment.
      </Text>

      <Divider mb="xl" color="dark.4" />

      <Stack gap="lg">
        {sourcesData.sources.map((source, index) => (
          <Card key={index} shadow="md" p="xl" radius="lg" withBorder className="modern-card">
            <Box mb="xs">
              <Badge
                variant="light"
                color={sourceDetails[index]?.color ?? "blue"}
                size="sm"
                mb="sm"
              >
                {sourceDetails[index]?.type ?? "Reference"}
              </Badge>
              <Anchor
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                c="blue.4"
                fw={600}
                size="md"
                display="block"
              >
                {source.name} ↗
              </Anchor>
            </Box>
            <Text c="gray.3" size="sm" lh={1.7}>
              {source.description}
            </Text>
          </Card>
        ))}
      </Stack>

      <Box mt={60} p="xl" style={{ borderTop: '1px solid #333' }}>
        <Title order={3} mb="sm" c="gray.2">About Our Data</Title>
        <Text c="gray.4" size="sm" lh={1.8}>
          Statistics such as symptom prevalence percentages and age distribution figures are
          estimates based on the available literature. Because hemiplegic migraine is rare,
          large-scale epidemiological studies are limited. Numbers should be interpreted as
          indicative rather than precise population figures. Where ranges exist in the
          literature, we have used the most commonly cited values.
        </Text>
      </Box>
    </Container>
  );
};

export default SourcesPage;
